import { normalize } from 'normalizr';

import api from '../../api';
import { schema } from '../../schema';
import { addEntities, removeEntity } from '../../actions';
import Logger from '../../../lib/Logger';

// ACTION TYPES

export const TYPES = {
  LIST_REQUEST: 'SMS_CONVERSATIONS/LIST_REQUEST',
  LIST_SUCCESS: 'SMS_CONVERSATIONS/LIST_SUCCESS',
  LIST_FAILURE: 'SMS_CONVERSATIONS/LIST_FAILURE',
  LIST_CLEAR: 'SMS_CONVERSATIONS/LIST_CLEAR',
  PATCH_REQUEST: 'SMS_CONVERSATIONS/PATCH_REQUEST',
  PATCH_SUCCESS: 'SMS_CONVERSATIONS/PATCH_SUCCESS',
  PATCH_FAILURE: 'SMS_CONVERSATIONS/PATCH_FAILURE',
  CLAIM_REQUEST: 'SMS_CONVERSATIONS/CLAIM_REQUEST',
  CLAIM_SUCCESS: 'SMS_CONVERSATIONS/CLAIM_SUCCESS',
  CLAIM_FAILURE: 'SMS_CONVERSATIONS/CLAIM_FAILURE',
  RESOLVE_REQUEST: 'SMS_CONVERSATIONS/RESOLVE_REQUEST',
  RESOLVE_SUCCESS: 'SMS_CONVERSATIONS/RESOLVE_SUCCESS',
  RESOLVE_FAILURE: 'SMS_CONVERSATIONS/RESOLVE_FAILURE',
  REOPEN_REQUEST: 'SMS_CONVERSATIONS/REOPEN_REQUEST',
  REOPEN_SUCCESS: 'SMS_CONVERSATIONS/REOPEN_SUCCESS',
  REOPEN_FAILURE: 'SMS_CONVERSATIONS/REOPEN_FAILURE',
  MARK_AS_READ_REQUEST: 'SMS_CONVERSATIONS/MARK_AS_READ_REQUEST',
  MARK_AS_READ_SUCCESS: 'SMS_CONVERSATIONS/MARK_AS_READ_SUCCESS',
  MARK_AS_READ_FAILURE: 'SMS_CONVERSATIONS/MARK_AS_READ_FAILURE',
  UPDATE_FROM_SOCKET: 'SMS_CONVERSATIONS/UPDATE_FROM_SOCKET',
  ASSIGN_REQUEST: 'SMS_CONVERSATIONS/ASSIGN_REQUEST',
  ASSIGN_SUCCESS: 'SMS_CONVERSATIONS/ASSIGN_SUCCESS',
  ASSIGN_FAILURE: 'SMS_CONVERSATIONS/ASSIGN_FAILURE',
};

// ACTION CREATORS

export function smsConversationListRequest(partnershipId, filter = null) {
  Logger.log(
    'debug',
    `[smsConversations.actions] smsConversationListRequest(${partnershipId}, ${filter})`
  );
  return {
    type: TYPES.LIST_REQUEST,
    partnershipId: partnershipId,
    filter: filter,
  };
}

export function smsConversationListSuccess(partnershipId, data, filter = null) {
  Logger.log(
    'debug',
    `[smsConversations.actions] smsConversationListSuccess(${partnershipId}, %j, ${filter})`,
    data
  );
  return {
    type: TYPES.LIST_SUCCESS,
    partnershipId: partnershipId,
    page: data.page,
    limit: data.limit,
    order: data.order,
    result: data.result,
    total: data.total,
    filter: filter,
    receivedAt: Date.now(),
  };
}
export function smsConversationListFailure(
  partnershipId,
  error,
  filter = null
) {
  Logger.log(
    'debug',
    `[smsConversations.actions] smsConversationListFailure(${partnershipId}, %j, ${filter})`,
    error
  );
  return {
    type: TYPES.LIST_FAILURE,
    partnershipId: partnershipId,
    error: error,
    filter: filter,
  };
}

export function clearSmsConversationLists() {
  Logger.log('debug', `[smsConversations.actions] clearSmsConversationLists()`);
  return {
    type: TYPES.LIST_CLEAR,
  };
}

export function smsConversationPatchRequest(partnershipId, id, data) {
  Logger.log(
    'debug',
    `[smsConversations.actions] smsConversationPatchRequest(${partnershipId}, ${id}, ${data})`
  );

  return {
    type: TYPES.PATCH_REQUEST,
    partnershipId: partnershipId,
    id: id,
    data: data,
  };
}

export function smsConversationPatchSuccess(partnershipId, id, data) {
  Logger.log(
    'debug',
    `[smsConversations.actions] smsConversationPatchSuccess(${partnershipId}, ${id}, ${data})`
  );

  return {
    type: TYPES.PATCH_SUCCESS,
    partnershipId: partnershipId,
    id: id,
    data: data,
    receivedAt: Date.now(),
  };
}

export function smsConversationPatchFailure(partnershipId, id, error) {
  Logger.log(
    'debug',
    `[smsConversations.actions] smsConversationPatchFailure(${partnershipId}, ${id}, %j)`,
    error
  );

  return {
    type: TYPES.PATCH_FAILURE,
    partnershipId: partnershipId,
    id: id,
    error: error,
  };
}

export function smsConversationClaimRequest(partnershipId, id, data) {
  Logger.log(
    'debug',
    `[smsConversations.actions] smsConversationClaimRequest(${partnershipId}, ${id}, ${data})`
  );

  return {
    type: TYPES.CLAIM_REQUEST,
    partnershipId: partnershipId,
    id: id,
    data: data,
  };
}

export function smsConversationClaimSuccess(partnershipId, id, data) {
  Logger.log(
    'debug',
    `[smsConversations.actions] smsConversationClaimSuccess(${partnershipId}, ${id}, ${data})`
  );

  return {
    type: TYPES.CLAIM_SUCCESS,
    partnershipId: partnershipId,
    id: id,
    data: data,
    receivedAt: Date.now(),
  };
}

export function smsConversationClaimFailure(partnershipId, id, error) {
  Logger.log(
    'debug',
    `[smsConversations.actions] smsConversationClaimFailure(${partnershipId}, ${id}, %j)`,
    error
  );
  return {
    type: TYPES.CLAIM_FAILURE,
    partnershipId: partnershipId,
    id: id,
    error: error,
  };
}

export function smsConversationResolveRequest(partnershipId, id, data) {
  Logger.log(
    'debug',
    `[smsConversations.actions] smsConversationResolveRequest(${partnershipId}, ${id}, ${data})`
  );

  return {
    type: TYPES.RESOLVE_REQUEST,
    partnershipId: partnershipId,
    id: id,
    data: data,
  };
}

export function smsConversationResolveSuccess(partnershipId, id, data) {
  Logger.log(
    'debug',
    `[smsConversations.actions] smsConversationResolveSuccess(${partnershipId}, ${id}, ${data})`
  );

  return {
    type: TYPES.RESOLVE_SUCCESS,
    partnershipId: partnershipId,
    id: id,
    data: data,
    receivedAt: Date.now(),
  };
}

export function smsConversationResolveFailure(partnershipId, id, error) {
  Logger.log(
    'debug',
    `[smsConversations.actions] smsConversationResolveFailure(${partnershipId}, ${id}, %j)`,
    error
  );
  return {
    type: TYPES.RESOLVE_FAILURE,
    partnershipId: partnershipId,
    id: id,
    error: error,
  };
}

export function smsConversationReopenRequest(partnershipId, id, data) {
  Logger.log(
    'debug',
    `[smsConversations.actions] smsConversationReopenRequest(${partnershipId}, ${id}, ${data})`
  );

  return {
    type: TYPES.REOPEN_REQUEST,
    partnershipId: partnershipId,
    id: id,
    data: data,
  };
}

export function smsConversationReopenSuccess(partnershipId, id, data) {
  Logger.log(
    'debug',
    `[smsConversations.actions] smsConversationReopenSuccess(${partnershipId}, ${id}, ${data})`
  );

  return {
    type: TYPES.REOPEN_SUCCESS,
    partnershipId: partnershipId,
    id: id,
    data: data,
    receivedAt: Date.now(),
  };
}

export function smsConversationReopenFailure(partnershipId, id, error) {
  Logger.log(
    'debug',
    `[smsConversations.actions] smsConversationReopenFailure(${partnershipId}, ${id}, %j)`,
    error
  );
  return {
    type: TYPES.REOPEN_FAILURE,
    partnershipId: partnershipId,
    id: id,
    error: error,
  };
}

export function smsConversationMarkAsReadRequest(partnershipId, id, data) {
  Logger.log(
    'debug',
    `[smsConversations.actions] smsConversationMarkAsReadRequest(${partnershipId}, ${id})`
  );
  return {
    type: TYPES.MARK_AS_READ_REQUEST,
    partnershipId: partnershipId,
    id: id,
    data: data,
  };
}

export function smsConversationMarkAsReadSuccess(partnershipId, id, data) {
  Logger.log(
    'debug',
    `[smsConversations.actions] smsConversationMarkAsReadSuccess(${partnershipId}, ${id})`
  );
  return {
    type: TYPES.MARK_AS_READ_SUCCESS,
    partnershipId: partnershipId,
    id: id,
    data: data,
    receivedAt: Date.now(),
  };
}

export function smsConversationMarkAsReadFailure(partnershipId, id, error) {
  Logger.log(
    'debug',
    `[smsConversations.actions] smsConversationMarkAsReadFailure(${partnershipId}, ${id}, %j)`,
    error
  );
  return {
    type: TYPES.MARK_AS_READ_FAILURE,
    partnershipId: partnershipId,
    id: id,
    error: error,
  };
}

export function smsConversationAssignRequest(partnershipId, id, data) {
  Logger.log(
    'debug',
    `[smsConversations.actions] smsConversationAssignRequest(${partnershipId}, ${id}, ${data})`
  );

  return {
    type: TYPES.ASSIGN_REQUEST,
    partnershipId: partnershipId,
    id: id,
    data: data,
  };
}

export function smsConversationAssignSuccess(partnershipId, id, data) {
  Logger.log(
    'debug',
    `[smsConversations.actions] smsConversationAssignSuccess(${partnershipId}, ${id}, ${data})`
  );

  return {
    type: TYPES.ASSIGN_SUCCESS,
    partnershipId: partnershipId,
    id: id,
    data: data,
    receivedAt: Date.now(),
  };
}

export function smsConversationAssignFailure(partnershipId, id, error) {
  Logger.log(
    'debug',
    `[smsConversations.actions] smsConversationAssignFailure(${partnershipId}, ${id}, %j)`,
    error
  );
  return {
    type: TYPES.ASSIGN_FAILURE,
    partnershipId: partnershipId,
    id: id,
    error: error,
  };
}

// API THUNK ACTION CREATORS

export function loadSmsConversations(
  partnershipId = null,
  page = 1,
  limit = 10,
  order = null,
  filter = null,
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.smsConversations.actions] loadSmsConversations(${partnershipId},  ${page}, ${limit}, ${order}, ###)`
  );

  return async function (dispatch) {
    dispatch(smsConversationListRequest(partnershipId, filter));

    // call API
    const response = await api.getSmsConversations(
      partnershipId,
      page,
      limit,
      order,
      filter
    );
    let success = false;

    // get sms conversations list success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Get API sms conversations list success. Partnership ID: ${partnershipId},  Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );

      const normalizedEntities = normalize(
        response.getIn(['data', 'sms_conversations']),
        [schema.smsConversation]
      );

      const data = {
        page: response.getIn(['data', 'page']),
        limit: response.getIn(['data', 'limit']),
        order: order,
        total: response.getIn(['data', 'total']),
        result: normalizedEntities.result,
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(smsConversationListSuccess(partnershipId, data, filter));
      success = true;
    } else if (1 === page && 204 === response.get('status')) {
      Logger.log(
        'info',
        `Get API sms conversations list success [empty]. Partnership ID: ${partnershipId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      const data = {
        page: page,
        limit: limit,
        order: order,
        total: 0,
        result: [],
      };
      dispatch(smsConversationListSuccess(partnershipId, data, filter));

      // get sms conversations list failure
    } else {
      Logger.log(
        'info',
        `Get API sms conversations list failure. Partnership ID: ${partnershipId}, Page: ${page}, Limit: ${limit}, Order: ${order}.`
      );
      dispatch(
        smsConversationListFailure(response.getIn(['data', 'error']), filter)
      );
    }

    // callback function
    cb(success);
  };
}

export function patchSmsConversation(
  partnershipId = null,
  id = null,
  data = {},
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.smsConversations.actions] patchSmsConversation(${partnershipId}, ${id}, %j, ###)`,
    data
  );

  return async function (dispatch, getState) {
    dispatch(smsConversationPatchRequest(partnershipId, id, data));

    // call API
    const response = await api.patchSmsConversation(partnershipId, id, data);
    let success = false;

    // patch sms conversation success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `Patch API sms conversation success. Partneship Id: ${partnershipId} ID: ${id}.`
      );

      const responseData = {
        id: response.getIn(['data', 'sms_conversation', 'id']),
        ...data,
      };

      if (data.clear_conversation) {
        dispatch(
          removeEntity({
            entityType: 'smsConversations',
            id: id,
          })
        );
      } else if (data.clear_messages) {
        dispatch(smsConversationPatchSuccess(partnershipId, id, responseData));

        const normalizedEntities = normalize(
          [response.getIn(['data', 'sms_conversation'])],
          [schema.smsConversation]
        );
        dispatch(addEntities(normalizedEntities));

        success = true;
        cb(success);
        return;
      } else {
        const normalizedEntities = normalize(
          [response.getIn(['data', 'sms_conversation'])],
          [schema.smsConversation]
        );
        dispatch(addEntities(normalizedEntities));
      }

      dispatch(smsConversationPatchSuccess(partnershipId, id, responseData));
      success = true;

      // patch sms conversation failure
    } else {
      Logger.log(
        'info',
        `Patch API sms conversation failure. Partneship Id: ${partnershipId} ID: ${id}.`
      );
      dispatch(
        smsConversationPatchFailure(
          partnershipId,
          id,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success);
  };
}

export function claimSmsConversation(
  partnershipId = null,
  id = null,
  data = {},
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.smsConversations.actions] claimSmsConversation(${partnershipId}, ${id}, %j, ###)`,
    data
  );

  return async function (dispatch, getState) {
    dispatch(smsConversationClaimRequest(partnershipId, id, data));

    // call API
    const response = await api.postClaimSmsConversation(
      partnershipId,
      id,
      data
    );
    let success = false;

    // claim sms message success
    if (201 === response.get('status')) {
      Logger.log(
        'info',
        `POST API claim sms conversations success. Post: ${response.getIn([
          'data',
          'sms_message',
          'id',
        ])}.`
      );

      const normalizedEntitySmsConversation = normalize(
        [response.getIn(['data', 'sms_conversation'])],
        [schema.smsConversation]
      );

      const normalizedEntitySmsMessage = normalize(
        [response.getIn(['data', 'sms_message'])],
        [schema.smsMessage]
      );

      const data = {
        id: response.getIn(['data', 'sms_message', 'id']),
      };

      dispatch(addEntities(normalizedEntitySmsMessage));
      dispatch(addEntities(normalizedEntitySmsConversation));
      dispatch(smsConversationClaimSuccess(partnershipId, id, data));

      const messageId = response.getIn(['data', 'sms_message', 'id']);
      if (messageId) {
        dispatch(
          markAsReadSmsMessages(partnershipId, id, {
            last_read_sms_message_id: messageId,
          })
        );
      }

      success = true;

      // claim sms message success
    } else {
      Logger.log('info', `POST API claim sms message success failure.`);
      dispatch(
        smsConversationClaimFailure(
          partnershipId,
          id,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success);
  };
}

export function resolveSmsConversation(
  partnershipId = null,
  id = null,
  data = {},
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.smsConversations.actions] resolveSmsConversation(${partnershipId}, ${id}, %j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(smsConversationResolveRequest(partnershipId, id, data));

    // call API
    const response = await api.postResolveSmsConversation(
      partnershipId,
      id,
      data
    );
    let success = false;

    // resolve sms message success
    if (201 === response.get('status')) {
      Logger.log(
        'info',
        `POST API resolve sms conversations success. Post: ${response.getIn([
          'data',
          'sms_message',
          'id',
        ])}.`
      );

      const normalizedEntitySmsConversation = normalize(
        [response.getIn(['data', 'sms_conversation'])],
        [schema.smsConversation]
      );

      const normalizedEntitySmsMessage = normalize(
        [response.getIn(['data', 'sms_message'])],
        [schema.smsMessage]
      );

      const data = {
        id: response.getIn(['data', 'sms_message', 'id']),
      };

      dispatch(addEntities(normalizedEntitySmsMessage));
      dispatch(addEntities(normalizedEntitySmsConversation));
      dispatch(smsConversationResolveSuccess(partnershipId, id, data));

      const messageId = response.getIn(['data', 'sms_message', 'id']);
      if (messageId) {
        dispatch(
          markAsReadSmsMessages(partnershipId, id, {
            last_read_sms_message_id: messageId,
          })
        );
      }

      success = true;

      // resolve sms message success
    } else {
      Logger.log('info', `POST API resolve sms message success failure.`);
      dispatch(
        smsConversationResolveFailure(
          partnershipId,
          id,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success);
  };
}

export function reopenSmsConversation(
  partnershipId = null,
  id = null,
  data = {},
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.smsConversations.actions] reopenSmsConversation(${partnershipId}, ${id}, %j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(smsConversationReopenRequest(partnershipId, id, data));

    // call API
    const response = await api.postReopenSmsConversation(
      partnershipId,
      id,
      data
    );
    let success = false;

    // reopen sms conversations success
    if (201 === response.get('status')) {
      Logger.log(
        'info',
        `POST API reopen sms conversations success. Post: ${response.getIn([
          'data',
          'sms_message_opened',
          'id',
        ])}.`
      );

      const normalizedEntitySmsConversation = normalize(
        [response.getIn(['data', 'sms_conversation'])],
        [schema.smsConversation]
      );

      const normalizedEntitySmsMessageOpen = normalize(
        [response.getIn(['data', 'sms_message_opened'])],
        [schema.smsMessage]
      );

      const normalizedEntitySmsMessagePendingToAssigned = normalize(
        [response.getIn(['data', 'sms_message_pending_to_assigned'])],
        [schema.smsMessage]
      );

      const data = {
        ids: [
          response.getIn(['data', 'sms_message_pending_to_assigned', 'id']),
          response.getIn(['data', 'sms_message_opened', 'id']),
        ],
      };

      dispatch(addEntities(normalizedEntitySmsConversation));
      dispatch(addEntities(normalizedEntitySmsMessageOpen));
      dispatch(addEntities(normalizedEntitySmsMessagePendingToAssigned));

      dispatch(smsConversationReopenSuccess(partnershipId, id, data));

      const lastMessageId = response.getIn([
        'data',
        'sms_message_opened',
        'id',
      ]);
      if (lastMessageId) {
        dispatch(
          markAsReadSmsMessages(partnershipId, id, {
            last_read_sms_message_id: lastMessageId,
          })
        );
      }

      success = true;

      // reopen sms conversations success
    } else {
      Logger.log('info', `POST API reopen sms conversations success failure.`);
      dispatch(
        smsConversationReopenFailure(
          partnershipId,
          id,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success);
  };
}

export function markAsReadSmsMessages(
  partnershipId = null,
  id = null,
  data = {},
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.smsConversations.actions] markAsReadSmsMessages(${partnershipId}, ${id}, %j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(smsConversationMarkAsReadRequest(partnershipId, id, data));

    // call API
    const response = await api.postMarkAsReadSmsConversation(
      partnershipId,
      id,
      data
    );
    let success = false;

    // mark as read sms conversations success
    if (200 === response.get('status')) {
      Logger.log(
        'info',
        `POST API mark as read sms conversations success. Post: ${response.getIn(
          ['data', 'sms_conversation', 'id']
        )}.`
      );

      const normalizedEntities = normalize(
        [response.getIn(['data', 'sms_conversation'])],
        [schema.smsConversation]
      );
      const data = {
        id: response.getIn(['data', 'sms_conversation', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(smsConversationMarkAsReadSuccess(partnershipId, id, data));
      success = true;

      // mark as read sms conversations success
    } else {
      Logger.log(
        'info',
        `POST API mark as read sms conversations success failure.`
      );
      dispatch(
        smsConversationMarkAsReadFailure(
          partnershipId,
          id,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success);
  };
}

export function updateSmsConversationFromSocket(
  partnershipId,
  profileId,
  smsConversation,
  smsMessage,
  isViewingConversation,
  isSentByMe = false
) {
  Logger.log(
    'debug',
    `[smsConversations.actions] updateSmsConversationFromSocket(${partnershipId}, ${profileId}, %j, %j, ${isViewingConversation}, ${isSentByMe})`,
    smsConversation,
    smsMessage
  );

  return function (dispatch, getState) {
    const state = getState();
    const smsConversations = state.entities.get('smsConversations');
    const conversationId = smsConversation.id;
    const existingSmsConversation = smsConversations
      ? smsConversations[conversationId]
      : null;

    const currentUnreadCount = existingSmsConversation?.unread_count || 0;
    // Check if message is a system event (KIND_SYSTEM_EVENT = 2)
    const isSystemEvent = smsMessage.kind === 2;

    // Calculate unread_count based on viewing state and message source:
    // - If viewing conversation: always reset to 0
    // - If sent by me: keep current count (don't increment)
    // - Otherwise: increment by 1 (for both system events and regular messages)
    const newUnreadCount = isViewingConversation
      ? 0
      : isSentByMe
      ? currentUnreadCount
      : currentUnreadCount + 1;

    // For system events, only update unread_count, don't update last_sms_message
    const fullSmsConversation = existingSmsConversation
      ? {
          ...existingSmsConversation,
          // Update fields that may have changed from socket
          assigned_to_profile: smsConversation.assigned_to_profile,
          conversation_status: smsConversation.conversation_status,
          ...(isSystemEvent ? {} : { last_sms_message: smsMessage }),
          unread_count: newUnreadCount,
        }
      : {
          ...smsConversation,
          ...(isSystemEvent ? {} : { last_sms_message: smsMessage }),
          unread_count: newUnreadCount,
        };

    const normalizedConversation = normalize(
      fullSmsConversation,
      schema.smsConversation
    );

    dispatch(addEntities(normalizedConversation));

    // Check if conversation is assigned to current user
    const isAssignedToMe =
      smsConversation.assigned_to_profile?.id === profileId;

    const action = {
      type: TYPES.UPDATE_FROM_SOCKET,
      partnershipId,
      conversationId: conversationId,
      isAssignedToMe: isAssignedToMe,
      receivedAt: Date.now(),
    };

    return dispatch(action);
  };
}

export function assignSmsConversation(
  partnershipId = null,
  id = null,
  data = {},
  cb = function () {}
) {
  Logger.log(
    'debug',
    `[state.smsConversations.actions] assignSmsConversation(${partnershipId}, ${id}, %j, ###)`,
    data
  );

  return async function (dispatch) {
    dispatch(smsConversationAssignRequest(partnershipId, id, data));

    // call API
    const response = await api.postAssignSmsConversation(
      partnershipId,
      id,
      data
    );
    let success = false;

    // assign sms message success
    if (201 === response.get('status')) {
      Logger.log(
        'info',
        `POST API assign sms conversations success. Post: ${response.getIn([
          'data',
          'sms_message',
          'id',
        ])}.`
      );

      const normalizedEntities = normalize(
        [response.getIn(['data', 'sms_message'])],
        [schema.smsMessage]
      );
      const data = {
        id: response.getIn(['data', 'sms_message', 'id']),
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(smsConversationAssignSuccess(partnershipId, id, data));

      const messageId = response.getIn(['data', 'sms_message', 'id']);
      if (messageId) {
        dispatch(
          markAsReadSmsMessages(partnershipId, id, {
            last_read_sms_message_id: messageId,
          })
        );
      }

      success = true;

      // assign sms message success
    } else {
      Logger.log('info', `POST API assign sms message success failure.`);
      dispatch(
        smsConversationAssignFailure(
          partnershipId,
          id,
          response.getIn(['data', 'error'])
        )
      );
    }

    // callback function
    cb(success);
  };
}

Logger.log('silly', `smsConversations.actions loaded.`);
